/**
 * Google Analytics 4 service
 */

const GA_MEASUREMENT_ID = import.meta.env.VITE_GA4_MEASUREMENT_ID;

let initialized = false;

/**
 * Initialize Google Analytics 4
 */
export function initGA4() {
    if (initialized || !GA_MEASUREMENT_ID) {
        return;
    }

    // Avoid loading twice
    if (document.querySelector('script[data-ga4]')) {
        initialized = true;
        return;
    }

    // Create dataLayer
    window.dataLayer = window.dataLayer || [];

    // Define gtag
    window.gtag = function () {
        window.dataLayer.push(arguments);
    };

    // Initial configuration
    window.gtag('js', new Date());

    window.gtag('config', GA_MEASUREMENT_ID, {
        send_page_view: false,
    });

    // Load Google Analytics script
    const script = document.createElement('script');

    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    script.dataset.ga4 = 'true';

    document.head.appendChild(script);

    initialized = true;
}

/**
 * Track a page view
 */
export function trackPageView(url) {
    if (!GA_MEASUREMENT_ID || !window.gtag) {
        return;
    }

    window.gtag('event', 'page_view', {
        page_title: document.title,
        page_location: window.location.origin + url,
        page_path: url,
    });
}

/**
 * Track custom events
 */
export function trackEvent(eventName, eventParams = {}) {
    if (!GA_MEASUREMENT_ID || !window.gtag) {
        return;
    }

    window.gtag('event', eventName, eventParams);
}